import createStringFacet from '../../createStringFacet';

export default createStringFacet({
  stateKey: 'mainSoilTypes',
  itemKey: (item) => item?.soilTypes?.[0]?.soilType,
});
